/* eslint-disable */
import modal from '@/components/Modal/modal'
import Vue, { PluginObject } from 'vue'

const plugin: PluginObject<Vue> = {
  install(Vue) {
    if (!Vue.prototype.$sui) {
      Vue.prototype.$sui = {}
    }
    Vue.prototype.$sui.modal = modal
  }
}

export default plugin
